import React, { useState, useEffect } from "react";
import '../../CSS/Cooperation.css';
import MenuSection from "./menuSection";
import { useLanguageData } from '../../hooks/useLanguageData'; // Remplacer useApiProxy
import SafeHTML from "../SafeHTML";
import { useTranslation } from 'react-i18next';

const Cooperation_bilateral = () => {
    const [multilateralData, setMultilateralData] = useState(null);
    const [decentralizedData, setDecentralizedData] = useState(null);
    const { t } = useTranslation();

    // Hook pour les données multilatérales
    const { 
        data: multilateralResponse, 
        loading: multilateralLoading, 
        error: multilateralError 
    } = useLanguageData('/api/v1/embassy/static-data?slug=cooperation_multilaterale_chine');

    // Hook pour les données décentralisées
    const { 
        data: decentralizedResponse, 
        loading: decentralizedLoading, 
        error: decentralizedError 
    } = useLanguageData('/api/v1/embassy/static-data?slug=cooperation_decentralise_chine');

    // Traiter les données multilatérales
    useEffect(() => {
        if (multilateralResponse?.data && multilateralResponse.data.length > 0) {
            // console.log('📊 Données API coopération multilatérale:', multilateralResponse);
            setMultilateralData(multilateralResponse.data[0]);
        }
    }, [multilateralResponse]);

    // Traiter les données décentralisées
    useEffect(() => {
        if (decentralizedResponse?.data && decentralizedResponse.data.length > 0) {
            // console.log('📊 Données API coopération décentralisée:', decentralizedResponse);
            setDecentralizedData(decentralizedResponse.data[0]);
        }
    }, [decentralizedResponse]);

    const loading = multilateralLoading || decentralizedLoading;

    // Composant pour Information indisponible
    const InfoIndisponible = () => (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            color: '#999',
            fontStyle: 'italic',
            fontSize: '1rem',
            textAlign: 'center',
            padding: '2rem',
            margin: '1rem 0'
        }}>
            {t('common.infoUnavailable')}
        </div>
    );

    // Composant de chargement
    if (loading) {
        return (
            <div className="cooperation-container">
                <div className="cooperation-content">
                    <MenuSection title={t('menuSection.cooperation')} />
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="cooperation-container">
            <div className="cooperation-content">
                <MenuSection title={t('menuSection.cooperation')} />

                <section className="section-2 mt-5">
                    {/* Section coopération multilatérale */}
                    {multilateralData ? (
                        <div className="presentation-multilaterale bloc-scrollable">
                            <div className="presentation-leadership-paragraphe contenu-scrollable" id="content-leader">
                                <SafeHTML html={multilateralData.content} />
                            </div>
                        </div>
                    ) : (
                        <InfoIndisponible />
                    )}

                    {/* Section coopération décentralisée */}
                    {decentralizedData ? (
                        <div className="presentation-decentralise bloc-scrollable">
                            <div className="presentation-leadership-paragraphe contenu-scrollable" id="content-leader">
                                <SafeHTML html={decentralizedData.content} />
                            </div>
                        </div>
                    ) : (
                        <InfoIndisponible />
                    )}
                </section>
            </div>

            {/* Styles pour le chargement */}
            <style>
                {`
                    .loading-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 2rem;
                        text-align: center;
                    }

                    .loading-spinner {
                        width: 40px;
                        height: 40px;
                        border: 4px solid #f3f3f3;
                        border-top: 4px solid #1a3c5e;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                        margin-bottom: 1rem;
                    }

                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }

                    .bloc-scrollable {
                        height: 530px;
                        overflow: hidden;
                    }

                    .contenu-scrollable {
                        height: 100%;
                        overflow-y: auto;
                        // padding-right: 5px;
                    }

                    /* Style de scrollbar discret */
                    .contenu-scrollable::-webkit-scrollbar {
                        width: 6px;
                    }

                    .contenu-scrollable::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 3px;
                    }

                    .contenu-scrollable::-webkit-scrollbar-thumb {
                        background: #1a3c5e;
                        border-radius: 3px;
                    }

                    /* Ajustement responsive */
                    @media (max-width: 768px) {
                        .bloc-scrollable {
                            height: 350px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Cooperation_bilateral;